import axios from 'axios'
import {
  MessageBox,
  Message
} from 'element-ui'
import store from '@/store'
import router from '@/router/index'
import i18n from "@/lang";

axios.defaults.timeout = 10000 // 响应时间
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8' // 配置请求头

// axios.defaults.baseURL = window.host = 'http://localhost:8081' // 开发环境
// axios.defaults.baseURL = window.host = 'http://221.224.53.27:20083' // 内部测试环境
// axios.defaults.baseURL = window.host = 'http://221.224.53.27:10031' // UAT环境
axios.defaults.baseURL = window.host = 'http://47.98.112.66:8081' // 生产环境
// axios.defaults.baseURL = window.host = 'https://www.srbiomedical.online:8081' // 生产环境

// 添加请求拦截器
axios.interceptors.request.use(
  config => {
    // config.data = JSON.stringify(config.data)
    // 携带token , token 从vuex store中获取
    // const token = store.getters.token

    config.headers['X-Language'] = store.state.app.language === 'en' ? 'en_US' : 'zh_CN'

    const userdata = store.state.user.userinfo
    if (userdata != null && userdata.token !== undefined && userdata.token != null) {
      config.headers['X-Token'] = userdata.token
    }

    // if (localStorage.getItem('userData')) {
    //   const data = JSON.parse(localStorage.getItem('userData'))
    //   const token = data.token
    //   if (token) {
    //     config.headers['X-Token'] = token
    //   }
    // }
    return config
  },
  error => {
    console.log(error)
  }
)

// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    const res = response.data

    if (res.code) {
      if (res.code !== 200) {
        // 提示错误消息
        if (res.code === 404 && window.layoutObj && window.layoutObj.loginDialogVisible) {
          //404时，已经弹出登录窗口，则不再提示信息
        }
        else {
          let timeoutObj = 0
          let alertMsgFun = () => {
            Message({
              message: res.message || 'error',
              type: 'error',
              duration: 5 * 1000
            })
            window.clearTimeout(timeoutObj)
          }
          if (res.code === 404) {
            timeoutObj = window.setTimeout(alertMsgFun, 10)
          }
          else {
            alertMsgFun()
          }
        }

        // token 过期
        if (res.code === 404) {
          // MessageBox.confirm('您已登录超时或在其他地方上线', '确定重新登录', {
          //   confirmButtonText: '重新登录',
          //   cancelButtonText: '取消',
          //   type: 'warning'
          // }).then(() => {
          //   // 清除store存储的token
          //   // location.reload()
          //   localStorage.removeItem('userData')
          //   window.location.href = '/#/login'
          //   // that.$router.push({ path:'/login'  })
          // })
          // localStorage.removeItem('userData')
          // window.location.href = '/#/login'

          //登录模态框
          if (window.layoutObj && store.getters.PermissionList) {
            window.layoutObj.openLoginDialog()
          }
          else {
            store.commit('setUserInfo', {})
            // window.location.href = '/#/login'
            router.push({ name: 'login' })
          }

          // that.$router.push({
          //   path: '/login'
          // })
        }
        // return Promise.reject(res.message || 'error')
      }
    }

    return res
  },
  error => {
    console.log(error)

    Message({
      type: "error",
      message: i18n.t("messageCommon.errorFormatter", [i18n.t("messageCommon.request")])
    })
  }
)

export default axios
